import { useEffect, useMemo } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { EnrichmentData, States } from '../constants';
import { fetchReviewPpsis } from '../actions';
import { getReviewPpsis, getIsFetching } from '../selectors';

// used first a dedicated call of globally, published dishes, but then
// I switched to the existing getReviewPPSIs with filter

const useGlobalPublishedPpsis = () => {
  const filter = useMemo(() => ({ status: States.PUBLISHED }), []);

  const dispatch = useDispatch();
  const isFetching = useSelector(getIsFetching);
  const globalPublishedPpsis = useSelector(getReviewPpsis);
  useEffect(() => {
    dispatch(fetchReviewPpsis(filter, 'IFS'));
  }, [dispatch]);

  return [isFetching, globalPublishedPpsis];
};

export default useGlobalPublishedPpsis;
